export const educationData = [
    {
        id: 1,
        institution: 'Panjab University',
        course: 'M.Sc. (Hons) in Physics',
        startYear: '0',
        endYear: '0'
    },
    {
        id: 2,
        institution: 'Indian Institute of Technology, Delhi',
        course: 'Ph.D. on Monsoon Dynamics & Atmospheric Modeling',
        startYear: '0',
        endYear: '0'
    },
    // {
    //     id: 3,
    //     institution: 'Hawking University, Cambridge',
    //     course: 'Master of Technology',
    //     startYear: '0',
    //     endYear: '0'
    // },
]